import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { borderRadius, skylineColor, stylisticFont } from './constants';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tabsAnatomy.keys);

const line = definePartsStyle(() => ({
  tab: {
    px: '30px',
    fontSize: '14px',
    fontWeight: '700',
    fill: 'white',
    _selected: {
      color: skylineColor,
      fill: skylineColor,
    },
    pb: '21px',
  },
  tabpanel: {
    padding: '25px 0px',
  },
  tablist: {
    borderColor: 'gray.400',
  },
}));

const solid = definePartsStyle(() => ({
  tab: {
    px: '30px',
    fontSize: '14px',
    fontWeight: '700',
    fill: 'white',
    _selected: {
      color: 'white',
      fill: 'white',
      bg: skylineColor,
      borderRadius,
    },
    p: '15px',
  },
  tabpanel: {
    padding: '25px 0px',
  },
  tablist: {
    borderColor: skylineColor,
  },
}));

export const tabsTheme = defineMultiStyleConfig({
  variants: {
    line,
    solid,
  },
  baseStyle: {
    tab: {
      fontFamily: stylisticFont,
    },
  },
});
